"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = require("../Button");

var _TextInput = require("../TextInput");

var _Icons = require("../Icons");

require("./QuantityInput.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ERROR_MESSAGE_DELAY = 1000;

var QuantityInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(QuantityInput, _React$Component);

  function QuantityInput(props) {
    var _this;

    _classCallCheck(this, QuantityInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(QuantityInput).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setMaxQuantityWithError", function () {
      var _this$props = _this.props,
          maxQuantity = _this$props.maxQuantity,
          onChange = _this$props.onChange;

      _this.setState({
        inputError: true
      }, function () {
        onChange(maxQuantity);
        setTimeout(function () {
          _this.setState({
            quantity: maxQuantity,
            inputValue: maxQuantity,
            inputError: false,
            displayQuantityError: true
          });
        }, ERROR_MESSAGE_DELAY);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setPreviousQuantity", function () {
      var onChange = _this.props.onChange;
      var quantity = _this.state.quantity;

      _this.setState({
        inputValue: quantity,
        displayQuantityError: false
      });

      onChange(quantity);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setNewQuantity", function (newQuantity) {
      var onChange = _this.props.onChange;

      _this.setState({
        quantity: newQuantity,
        inputValue: newQuantity,
        displayQuantityError: false
      });

      onChange(newQuantity);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "increaseQuantity", function () {
      var newQuantity = _this.state.quantity + _this.props.quantityIncrement;

      _this.setState({
        quantity: newQuantity,
        inputValue: newQuantity,
        displayQuantityError: false
      });

      _this.props.onChange(newQuantity);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "decreaseQuantity", function () {
      var newQuantity = _this.state.quantity - _this.props.quantityIncrement;

      _this.setState({
        quantity: newQuantity,
        inputValue: newQuantity,
        displayQuantityError: false
      });

      _this.props.onChange(newQuantity);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
      var value = e.target.value;

      _this.setState({
        inputValue: value
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validateQuantity", function () {
      var _this$props2 = _this.props,
          maxQuantity = _this$props2.maxQuantity,
          minQuantity = _this$props2.minQuantity;
      var inputValue = _this.state.inputValue;
      var textInputNumber = parseInt(inputValue, 10);

      if (maxQuantity && textInputNumber > maxQuantity) {
        _this.setMaxQuantityWithError();
      } else if (!textInputNumber || textInputNumber < minQuantity) {
        _this.setPreviousQuantity();
      } else {
        _this.setNewQuantity(textInputNumber);
      }
    });

    var _quantity = props.quantity,
        _minQuantity = props.minQuantity;
    var baseQuantity = _quantity < _minQuantity ? _minQuantity : _quantity;
    _this.state = {
      quantity: baseQuantity,
      inputValue: baseQuantity,
      inputError: false,
      displayQuantityError: false
    };
    return _this;
  }

  _createClass(QuantityInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateQuantity();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          quantity = _this$state.quantity,
          inputError = _this$state.inputError,
          displayQuantityError = _this$state.displayQuantityError;
      var _this$props3 = this.props,
          className = _this$props3.className,
          maxQuantity = _this$props3.maxQuantity,
          minQuantity = _this$props3.minQuantity,
          maximumQuantityErrorMessage = _this$props3.maximumQuantityErrorMessage,
          successMessage = _this$props3.successMessage,
          quantityIncrement = _this$props3.quantityIncrement,
          disabled = _this$props3.disabled;
      var classNames = (0, _classnames.default)('quantity-input__wrap', className, {
        'quantity-input--max-quantity-message': !!maximumQuantityErrorMessage,
        'quantity-input--display-error': displayQuantityError
      });
      return _react.default.createElement("div", {
        className: classNames
      }, _react.default.createElement("div", {
        className: "quantity-input"
      }, _react.default.createElement(_Button.Button, {
        className: "quantity-input__btn quantity-input__button--decrease",
        type: _Button.buttonTypes.GHOST_DARK,
        size: _Button.buttonSizes.SMALL,
        onClick: this.decreaseQuantity,
        isDisabled: quantity <= minQuantity || disabled
      }, _react.default.createElement(_Icons.IconUiMinus, null)), _react.default.createElement(_TextInput.TextInput, {
        className: "quantity-input__text-input",
        type: "number",
        inputMode: "numeric",
        min: minQuantity,
        max: maxQuantity,
        pattern: "[0-9]*",
        value: this.state.inputValue,
        onChange: this.handleInputChange,
        onBlur: this.validateQuantity,
        error: inputError,
        disableTyping: quantityIncrement > 1,
        disabled: disabled
      }), _react.default.createElement(_Button.Button, {
        className: "quantity-input__btn quantity-input__button--increase",
        type: _Button.buttonTypes.GHOST_DARK,
        size: _Button.buttonSizes.SMALL,
        onClick: this.increaseQuantity,
        isDisabled: quantity === maxQuantity || disabled
      }, _react.default.createElement(_Icons.IconUiPlus, null))), successMessage && _react.default.createElement("div", {
        className: "quantity-input__message quantity-input__message-panel is-success"
      }, successMessage), maximumQuantityErrorMessage && _react.default.createElement("div", {
        className: "quantity-input__message quantity-input__message-panel is-error"
      }, maximumQuantityErrorMessage));
    }
  }]);

  return QuantityInput;
}(_react.default.Component);

QuantityInput.propTypes = {
  /** Any classnames that you want to apply to the top level div */
  className: _propTypes.default.string,

  /** Current quantity value */
  quantity: _propTypes.default.number.isRequired,

  /** The minimum allowed quantity */
  minQuantity: _propTypes.default.number,

  /** The maximum allowed quantity */
  maxQuantity: _propTypes.default.number,

  /** The number to increment / decrement the quantity by */
  quantityIncrement: _propTypes.default.number,

  /**
      A Function that will be called after every quantity update
      with the value of the update quantity
  */
  onChange: _propTypes.default.func.isRequired,

  /** The message to display when the maximum quantity is exceeded */
  maximumQuantityErrorMessage: _propTypes.default.string,

  /** The message to display in the green message box under the input */
  successMessage: _propTypes.default.string,

  /** Disable controls and text input */
  disabled: _propTypes.default.bool
};
QuantityInput.defaultProps = {
  minQuantity: 1,
  quantityIncrement: 1
};
var _default = QuantityInput;
exports.default = _default;